<div class="text-content">1. Cree el contenedor donde se visualizará el botón de pago web.
</div>
<div class="code-content-sm">
    <!--<iframe src="https://pastebin.com/embed_iframe/CJAkGSYN"
                                    style="border:none;width:100%;height:100px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="21747c6572bf86c8d546928771aae93a"
        fileName="epago-web-body-div.html"></ng-gist>
</div>
<aside class="note"><b>Nota:</b> Las dimensiones de este contenedor deben ser de 370px de
    ancho por 590px de alto.
</aside>
<div class="text-content">2. Inicialice y configure el formulario de pago (visualmente, el
    ambiente de procesamiento de pago y la gestión visual de la respuesta).
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/1rTuStSk"
                                    style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="565f438cf2a60c5d2d98ad42d9b369ec"
        fileName="epago-web-func-noform-startpayment.js"></ng-gist>
</div>
<aside class="note">
    <b>Nota:</b> El mensaje de "Denegación" del procesador se obtiene:<br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Mensaje:</b> response.data.result.message<br>
    <b>Nota 2:</b> Para revisar el detalle del mensaje de respuesta diríjase a la sección de <a routerLink="/api-events">"API de Eventos"</a><br>
</aside>
<div class="text-content">3. Setee los datos de la orden o pedido.
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/vx78zaBe"
                                    style="border:none;width:100%;height:600px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="1646959c55b4e1b4d3640145a53187d0"
        fileName="epago-web-func-buildTransaction.js"></ng-gist>
</div>
<div class="text-content">4. Setee los datos de autenticación.
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/T9xYvXHR"
                                    style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="fb766bc7d3a4b8974dada53db86db1d0"
        fileName="epago-web-func-buildAuthentication.js"></ng-gist>
</div>
<aside class="note"><b>Nota:</b> El APIKey y SignatureKey están disponibles en la plataforma
    de gestión de epago
</aside>
<div class="text-content">5. Las siguientes funciones son utilitarias y deben ser
    utilizadas solo como "referencia".
</div>
<div class="code-content-md">
    <!--<iframe src="https://pastebin.com/embed_iframe/VPfbEaw1"
                                    style="border:none;width:100%;height:400px;padding-bottom:10px;"></iframe>-->
    <ng-gist userName="synapdevelopment" gistId="3d76955325c2cce5e90f7e7d3fcfdc28"
        fileName="epago-web-func-utilities.js"></ng-gist>
</div>